<template>
  <div id="app">
    <HeaderSystemicoComponent
        id="systemico_header"
        variant="blue"
        :menuActive="true"
        lang="EN"
        country="USA"
        class="header_nav__active p-0"
        loginURL="https://systemico.net/login"
    />
    <router-view/>
  </div>
</template>

<style lang="scss">
@import 'packages/systemico.ui/variables.scss';
html{
  font-size:16px;
  font-family:$font-quicksand;
}
*{
  font-family:$font-quicksand;
}
main{
  margin-top:3.5rem;
}
</style>
<script>
import HeaderSystemicoComponent from "./packages/systemico.ui/components/headers/HeaderSystemicoComponent.vue";
export default {
  name: 'App',
  components: {
    HeaderSystemicoComponent
  },
  data () {
    return {
      menuActive: false
    }
  },
  beforeMount() {

  }
}
</script>
